import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import LinkEditing from '@ckeditor/ckeditor5-link/src/linkediting';
import LinkUI from '@ckeditor/ckeditor5-link/src/linkui';


export default class CustomLinkUI extends Plugin {
   static get requires() {
      return [LinkEditing, LinkUI];
   }

   init() {
      const editor = this.editor;
      const linkUI = editor.plugins.get(LinkUI);
      const contextualBalloonPlugin = editor.plugins.get('ContextualBalloon');

      var flLoadedTreeview = false;

      this.listenTo(contextualBalloonPlugin, 'change:visibleView', (evt, name, visibleView) => {
         if (visibleView === linkUI.formView) {
            if (!flLoadedTreeview) {
               this.linkFormView = linkUI.formView;
               this.dropdown = this.createDropdown();

               flLoadedTreeview = true;
            } else {
               var linkTypeSelect = this.getElement("#linkTypeSelect");

               if (linkTypeSelect) {
                  linkTypeSelect.value = "1";

                  const internalLinkSelect = this.getElement("#internalLinkSelect");
                  const findOnServerButton = this.getElement("#findOnServerButton");

                  //if (checkbox)
                  //   checkbox.checked = false;

                  //if (select)
                  //   select.style.display = 'none';

                  //this.linkFormView.urlInputView.element.style.display = 'block';

                  this.showOrHideByLinkType("1", this, internalLinkSelect, findOnServerButton);
               }
            }

            contextualBalloonPlugin.view.element.style.zIndex = 9999;
         }
      });

      window.addEventListener("message", function (event) {
         receiveMessageFromPopup(editor, event);
      });
   }


   createDropdown() {
      const editor = this.editor;
      const linkCommand = editor.commands.get('link');

      var options = "";

      $.ajax({
         type: "GET",
         url: "/Admin/CommonAuthenticatedAjaxHandler.ashx?action=getPageList&csid=" + editor.config.get("csid"),
         async: false,
         success: function (data) {
            options = data;
         }
      });


      const linkTypeSelectHTML = `
      <div class="ck ck-labeled-field-view link-type-select">
         <label for="linkTypeSelect" data-cke-translatable="true">${editor.t('Tipologia di link')}</label>
         <select name="linkType" id="linkTypeSelect" class="form-select input-type-dropdownlist w-100 p-1" style="border: 1px solid #eaeaea;">
            <option value='1'>${editor.t('Link')}</option>
            <option value='2'>${editor.t('Pagina interna')}</option>
            <option value='3'>${editor.t('File')}</option>
         </select>
      </div>`;

      const internalLinkSelectHTML = `
      <div class="ck ck-labeled-field-view internal-link-select">
         <select name="internalLink" id="internalLinkSelect" class="form-select input-type-dropdownlist w-100 p-1" style="border: 1px solid #eaeaea;">
            ` + options + `
         </select>
      </div>`;

      const findOnServerButtonHTML = `
      <button class="ck ck-button ck-button-action ck-off ck-button_with-text mt-2 ms-2" type="button">
         <span class="ck ck-button__label" id="findOnServerButton">${editor.t('Cerca sul server')}</span>
      </button>`

      const balloon = editor.plugins.get('ContextualBalloon');
      const balloonElement = balloon.view.element;

      var linkFormElement = balloonElement.querySelector("form.ck-link-form");

      if (linkFormElement) {

         linkFormElement.insertAdjacentHTML('afterbegin', internalLinkSelectHTML);
         linkFormElement.insertAdjacentHTML('afterbegin', findOnServerButtonHTML);
         linkFormElement.insertAdjacentHTML('afterbegin', linkTypeSelectHTML);

         const linkTypeSelect = balloonElement.querySelector('#linkTypeSelect');
         const internalLinkSelect = balloonElement.querySelector('#internalLinkSelect');
         const findOnServerButton = balloonElement.querySelector('#findOnServerButton');

         linkTypeSelect.addEventListener('change', event => {
            const linkType = event.target.value;
            this.showOrHideByLinkType(linkType, this, internalLinkSelect, findOnServerButton);
         });

         internalLinkSelect.style.display = 'none';
         findOnServerButton.parentElement.style.display = 'none';

         internalLinkSelect.addEventListener('change', event => {
            linkCommand.execute(event.target.value);
            balloon.remove(this.linkFormView);
         });

         findOnServerButton.addEventListener('click', event => {
            const popupUrl = stringFormat("/Resources/FileManager/FileManager.aspx?isFromCK=true&CKSelector={0}&currentSiteId={1}&rootFolderId={2}&rootFolderName={3}&ignoreUserPermissions={4}&filter=&showUploadAction={6}&isForLink=true", editor.sourceElement.id, editor.config.get("currentSiteId"), editor.config.get("rootFolderId"), editor.config.get("rootFolderName"), editor.config.get("ignoreUserPermissions"), editor.config.get("showUploadAction"));
            const popupOptions = "width=1150,height=650";

            window.open(popupUrl, "Popup", popupOptions);
         });
      }

      return internalLinkSelectHTML;
   }


   //#region Utility


   getElement(idToGet) {
      const balloonElement = this.editor.plugins.get("ContextualBalloon").view.element;
      return balloonElement.querySelector(idToGet);
   }


   showOrHideByLinkType(linkType, el, internalLinkSelect, findOnServerButton) {
      switch (linkType) {
         case "1":
            el.linkFormView.urlInputView.element.style.display = 'block';
            internalLinkSelect.style.display = 'none';
            findOnServerButton.parentElement.style.display = 'none';

            break;
         case "2":
            el.linkFormView.urlInputView.element.style.display = 'none';
            internalLinkSelect.style.display = 'block';
            findOnServerButton.parentElement.style.display = 'none';

            break;
         case "3":
            el.linkFormView.urlInputView.element.style.display = 'none';
            internalLinkSelect.style.display = 'none';
            findOnServerButton.parentElement.style.display = 'block';

            break;
      }
   }


   //#endregion


}

function receiveMessageFromPopup(editor, event) {

   if (typeof event.data == "string" && event.data.startsWith("FileManagerDataSentLink|")) {

      var data = event.data.split('|');

      //if (data[0] == "FileManagerDataSentLink" && data[1] == editor.sourceElement.id) {
      if (editor.sourceElement && data[1] == editor.sourceElement.id) {

         //var fileName = data[3];
         //var selection = editor.model.document.selection;
         //var range = selection.getFirstRange();
         //var selectedText;
         //for (var item of range.getItems())
         //   selectedText = item.data;

         //var anchorTag = "<a href='" + data[2] + "'>" + (selectedText ? selectedText : fileName) + "</a>";

         //const viewFragment = editor.data.processor.toView(anchorTag);
         //const modelFragment = editor.data.toModel(viewFragment);
         //editor.model.insertContent(modelFragment);

         const linkCommand = editor.commands.get('link');
         //const balloon = editor.plugins.get('ContextualBalloon');

         linkCommand.execute(data[2]);
         //balloon.remove(el.linkFormView);
      }
   }
}